export const allDateFormats = [
    'P',
    'PP',
    'MM-dd-yy',
    'dd-MM-yy',
    'dd-MM-yyyy',
    'yyyy-MM-dd',
];
export const allTimeFormats = ['HH:mm', 'HH:mm:ss', 'hh:mm a', 'hh:mm:ss a'];
